import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowLeft, Loader2 } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/lib/auth';
export default function Login() {
  const { user, loading, refresh } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { if (!loading && user?.is_editor) navigate('/dashboard', {replace:true}); }, [user, loading, navigate]);
  async function login(e) {
    e.preventDefault(); setBusy(true); setError('');
    try {
      const {error} = await supabase.auth.signInWithPassword({email:email.trim(), password});
      if (error) throw error;
      await refresh(); navigate('/dashboard');
    } catch { setError('No se pudo iniciar sesión. Revisa tu correo y contraseña.'); }
    finally {setBusy(false);}
  }
  return <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-16"><div className="w-full max-w-md">
    <button onClick={()=>navigate('/')} className="inline-flex items-center gap-2 font-display font-bold uppercase text-xs tracking-wider text-slate-500 mb-6"><ArrowLeft className="w-4 h-4"/> Volver al sitio</button>
    <div className="bg-white border-2 border-slate-950 p-8 md:p-10 btn-brutal">
      <div className="flex items-center justify-center w-14 h-14 bg-amber-500 border-2 border-slate-950 mb-6"><ShieldCheck className="w-7 h-7"/></div>
      <div className="font-mono text-xs tracking-[0.3em] uppercase text-amber-600 mb-2">Panel de administración</div>
      <h1 className="font-display text-3xl font-black uppercase tracking-tight">Acceso restringido</h1>
      <p className="mt-3 text-slate-600 text-sm">Ingresa con tu cuenta autorizada para administrar el sitio.</p>
      <form onSubmit={login} className="mt-6 space-y-4">
        <label className="block text-sm">Correo electrónico<input aria-label="Correo electrónico" type="email" autoComplete="username" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-1 w-full border border-slate-300 p-3"/></label>
        <label className="block text-sm">Contraseña<input aria-label="Contraseña" type="password" autoComplete="current-password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-1 w-full border border-slate-300 p-3"/></label>
        {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
        <button disabled={busy} className="w-full bg-slate-950 text-white font-display font-bold uppercase px-6 py-4 flex justify-center gap-2 disabled:opacity-60">{busy && <Loader2 className="w-5 h-5 animate-spin"/>} Iniciar sesión</button>
      </form>
    </div>
  </div></div>;
}
